// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"35c383a7","113":"bd2a5c20","318":"39afcb18","483":"bb278166","785":"3a7dae76","845":"f6fbf018","998":"992bce51"}[chunkId] + ".chunk.js";
};